import { Button, Separator, Skeleton } from '@mokoboko/components';
import { HowToBookInstructions } from './how-to-book-instructions';

interface PostPurchaseActionsProps {
  isAuthenticated: boolean;
  onLoginClick: () => void;
  onBookClass: () => void;
  secondaryLabel: string;
  onSecondaryClick: () => void;
}

export const PostPurchaseActions = ({
  isAuthenticated,
  onLoginClick,
  onBookClass,
  secondaryLabel,
  onSecondaryClick,
}: PostPurchaseActionsProps) => (
  <>
    {!isAuthenticated && (
      <>
        <HowToBookInstructions onLoginClick={onLoginClick} />
        <Separator className="my-6" />
      </>
    )}

    <div className="flex flex-col gap-3">
      <p className="text-base font-semibold text-gray-900">
        Book your next class
      </p>
      <Button onClick={onBookClass} size="lg" className="w-full justify-center">
        Book class
      </Button>
      <Button
        variant="secondary-gray"
        onClick={onSecondaryClick}
        size="lg"
        className="w-full justify-center"
      >
        {secondaryLabel}
      </Button>
    </div>
  </>
);

export const PostPurchaseActionsSkeleton = () => (
  <>
    <div>
      <Skeleton text="body" width={176} />
      <ol className="mt-3 flex flex-col gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <li key={i} className="flex items-center gap-3.5">
            <Skeleton isCircle height={28} />
            <Skeleton text="body-sm" className="w-full" />
          </li>
        ))}
      </ol>
    </div>

    <Separator className="my-6" />

    <div className="flex flex-col gap-3">
      <Skeleton text="body" width={160} />
      <Skeleton isRounded height={44} width="100%" />
      <Skeleton isRounded height={44} width="100%" />
    </div>
  </>
);
